import { MetricThreshold } from "@/types/threshold"

const STORAGE_KEY = "metric-thresholds-proto"

type ThresholdStore = Record<string, MetricThreshold[]>

/**
 * 프로토타입용 localStorage 기반 임계값 저장
 * Backend API 반영 전까지 임시로 사용
 * key: 테이블 title (고유 식별자로 사용)
 */
export function saveThresholds(tableTitle: string, thresholds: MetricThreshold[]): void {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    const store: ThresholdStore = stored ? JSON.parse(stored) : {}

    if (thresholds.length > 0) {
      store[tableTitle] = thresholds
    } else {
      delete store[tableTitle]
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(store))
  } catch (e) {
    console.error("Failed to save thresholds to localStorage:", e)
  }
}

export function loadThresholds(tableTitle: string): MetricThreshold[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (!stored) return []

    const store: ThresholdStore = JSON.parse(stored)
    return store[tableTitle] || []
  } catch (e) {
    console.error("Failed to load thresholds from localStorage:", e)
    return []
  }
}
